/**
 * objectSomeTrueチェック
 * 1つでもtrueが含まれていればtrue
 */
export function someTrue(targetObject: any) {
  let someFocus = false;
  Object.keys(targetObject).forEach((keyName) => {
    if (typeof targetObject[keyName] === 'object') {
      // objectの場合は中身までforEachする
      Object.keys(targetObject[keyName]).forEach((insideKeyName) => {
        if (targetObject[keyName][insideKeyName]) {
          someFocus = true;
        }
      });
    } else if (targetObject[keyName]) {
      someFocus = true;
    }
  });
  return someFocus;
}
